import {Injectable} from '@angular/core';

declare const history: any;
/**
 * A tiny service to save router state without accessing document
 * Currently makes use of router.events, see LayoutComponent
 */
@Injectable({
  providedIn: 'root'
})
export class RoutingStateService {
  public history = [];
  public startHistoryIndex: number;
  constructor() {
    this.startHistoryIndex = history.length;
  }

  public saveRouting(previousUrl): void {
    const url = (previousUrl || '').split('?')[0];
    if (url !== '/') {
      this.history = [...this.history, previousUrl];
    }
  }
  getPreviousUrl() {
    const l = this.history.length;
    return this.history[((l >= 2) ? l - 2 : 0)];
  }

  /**
   * Calculate the number of navigation required to get to
   * the first history index when on application load
   */
  getFirstNavigationPage() {
    return history.length - (history.length - this.startHistoryIndex);
  }
}
